(function () {
	const HEADER_SELECTOR = '.header';
	const HOME_SELECTOR = '.home';
	const TRANSPARENT_CLASS = 'transparent';

	function init() {
		if ( !document.querySelector( HOME_SELECTOR ) ) {
			return;
		}

		const header = document.querySelector( HEADER_SELECTOR );
		if ( !header ) {
			return;
		}

		const updateHeaderTransparency = () => {
			header.classList.toggle( TRANSPARENT_CLASS, window.scrollY <= 0 );
		};

		updateHeaderTransparency();
		window.addEventListener( 'scroll', updateHeaderTransparency, { passive: true } );
	}

	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', init );
	} else {
		init();
	}
})();
